import { Dialog } from "@radix-ui/react-dialog";
import { Button } from "@somethings-ui/web";
import { Loader2 } from "lucide-react";

interface SendConfirmationModalProps {
  showSendConfirmation: boolean;
  setShowSendConfirmation: (show: boolean) => void;
  onConfirmSend: () => void;
  isUploading?: boolean;
  recipientName: string;
}

export function SendConfirmationModal({
  showSendConfirmation,
  setShowSendConfirmation,
  onConfirmSend,
  isUploading = false,
  recipientName,
}: SendConfirmationModalProps) {
  if (!showSendConfirmation) return null;

  return (
    <Dialog open={showSendConfirmation} onOpenChange={setShowSendConfirmation}>
      <div className="fixed inset-0 flex items-center justify-center bg-black/50">
        <div className="mx-4 w-full max-w-md rounded-lg bg-white p-6">
          <h2 className="mb-4 text-lg font-semibold">
            Are you sure you want to send your recording?
          </h2>
          <p className="mb-6 text-sm text-gray-600">
            Please confirm this monthly update is for{" "}
            <strong>{recipientName}</strong>.
          </p>
          <div className="flex justify-end gap-3">
            <Button
              onClick={() => setShowSendConfirmation(false)}
              variant="secondary"
              size="md"
              disabled={isUploading}
            >
              Cancel
            </Button>
            <Button
              onClick={onConfirmSend}
              disabled={isUploading}
              variant="primary"
              size="md"
            >
              {isUploading ? (
                <div className="flex items-center gap-2">
                  <Loader2 className="h-4 w-4 animate-spin" />
                  <span>Sending...</span>
                </div>
              ) : (
                "Send recording"
              )}
            </Button>
          </div>
        </div>
      </div>
    </Dialog>
  );
}
